/**
 * Google Gemini API service for product rating
 * This service handles communication with Google's Gemini API to analyze products
 */

// You'll need to add the Google Gemini API client
// npm install @google/generative-ai


import FirebaseHelper from './firestore/index.ts';
/**
 * Rates a product using Google Gemini API
 * @param {Object} productData - The product data to rate
 * @param {string} productData.imgUrl - URL of the product image
 * @param {string} productData.brand - Brand name of the product
 * @param {string} productData.name - Name of the product
 * @param {string} productData.variation - Color or variation of the product
 * @param {Object} options - Additional options (optional)
 * @returns {Promise<Object>} - JSON response from Gemini API
 */
export const rateProduct = async (productData = {}) => {

    const {brand, name} = productData;

    // Construct prompt for the API
    const prompt = `
    Product details:
    Brand: ${brand}
    Product Name: ${name}

    Your task is to examine the product information submitted by users on the internet. 

    A good product image should have the following qualities:
    - a clean, single colored background. 
    - one object in the center of the image in focus and is well lit
    - text on the product such as brand name should be clearly visible
    - with plenty of empty space around it.
    - the image should not be blurry or pixelated.
    If each of these criteria is met, rate the image as 5. If none of the criteria is met, rate the image as 0.
    Provide comments on the image quality.

    Read all the text visible on the product image.
    
    Rate the brand name on a scale of 1 to 5. The brand name of the product should be a known brand, not a made-up name. If the name of the brand is
    a real, known brand and the spelling and case of each letter is correct, give it 5. if the brand name is a fake one, give it 0. 
    Provide comments on the brand name spelling quality.
      
    provide suggestion on the type of product

    Return a JSON object with the following structure:
    {
      "imageRating": {score},
      "imageComments": {imageComments},
      "brandRating": {score},
      "brandComments": {brandComments},
      "textRead": {result},
       "type": {productType}
    }
    `;

    

    return await FirebaseHelper.analyzeProduct(productData, prompt, "gemini-2.0-flash-lite")
   
    
    // Call the Gemini API
    // const result = await model.generateContent(query);
    
};

export default {
  rateProduct
}; 